// src/main.jsx
// STATUS: stable | UPDATED: 2026-08-27
// LOG:
//   2026-08-27  ColorModeScript added ahead of the app so the stored (or system)
//               colour mode is applied before first paint. Without it a dark-mode
//               user gets a white flash on every load, which on a phone reads as
//               a broken app rather than a slow one.
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
// React entry point. Wraps the app in ChakraProvider, BrowserRouter, and our theme.

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import theme from './theme'
import App from './App'
import { AuthProvider } from './context/AuthProvider.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
)
